var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.59297 18.7939C2.11558 18.7939 1.65774 18.6043 1.32018 18.2667C0.982611 17.9292 0.792969 17.4713 0.792969 16.9939V2.59395C0.792969 2.11656 0.982611 1.65872 1.32018 1.32116C1.65774 0.98359 2.11558 0.793948 2.59297 0.793948H9.79297C10.0779 0.793486 10.36 0.84939 10.6232 0.95844C10.8864 1.06749 11.1255 1.22753 11.3266 1.42935L14.5558 4.65855C14.7581 4.8597 14.9186 5.09896 15.028 5.36249C15.1374 5.62603 15.1934 5.90862 15.193 6.19395V16.9939C15.193 17.4713 15.0033 17.9292 14.6658 18.2667C14.3282 18.6043 13.8704 18.7939 13.393 18.7939H2.59297Z",
    stroke: "#08478C",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79297 0.793945V5.29394C9.79297 5.53264 9.88779 5.76156 10.0566 5.93034C10.2254 6.09912 10.4543 6.19394 10.693 6.19394H15.193",
    stroke: "#08478C",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18672 7.09375H4.38672",
    stroke: "#08478C",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5867 10.6934H4.38672",
    stroke: "#08478C",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5867 14.2939H4.38672",
    stroke: "#08478C",
    strokeWidth: 1.58824,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTextIcon);
export default __webpack_public_path__ + "static/media/file-text-icon.35aff440eb8f44d6d2cc9b5fef58a4b8.svg";
export { ForwardRef as ReactComponent };